import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../ui-inlined-svg/ui-inlined-svg';
import iconStyle from './ui-placeholder-icon.css?inline';

const CName = 'ui-placeholder-icon';

@customElement(CName)
export class UIPlaceholderIcon extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/placeholder-icon.svg', import.meta.url).href;
    return html`<ui-inlined-svg .css=${UIPlaceholderIcon.styles} .defer=${true} .src=${assetUrl}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIPlaceholderIcon;
  }
}
